const defaultState = {
  selectedFleetId: undefined,
};

const getters = {
  selectedFleetId: state => state.selectedFleetId,
};

const actions = {
  setSelectedFleet(context, fleetId) {
    context.commit('setSelectedFleet', fleetId);
  },
  clearSelectedFleet(context) {
    context.commit('setSelectedFleet', undefined);
  },
};

const mutations = {
  setSelectedFleet(state, fleetId) {
    state.selectedFleetId = fleetId;
  },
};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  actions,
  mutations,
};
